var $ = require('jquery');

$(function () {
    $('#filters form').on('change', function() {
        $(this).submit();
    });
});



//////////////////
// WEBPACK FOOTER
// ./site/js/legends_picks.js
// module id = 19
// module chunks = 5